import { render } from "./AppTopbar.vue?vue&type=template&id=0b0f3034&scoped=true"
import script from "./AppTopbar.vue?vue&type=script&lang=js"
export * from "./AppTopbar.vue?vue&type=script&lang=js"

import "./AppTopbar.vue?vue&type=style&index=0&id=0b0f3034&lang=scss&scoped=true"

import exportComponent from "/builds/apps/elevate/shepherd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0f3034"]])

export default __exports__